var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-96 border-t border-gray-400 overflow-hidden p-2 text-sm"},[_c('python-live',{attrs:{"code":_vm.code},on:{"skip":_vm.handleSkip}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }